// const 路由文件严格按照目录树结构来写,请勿随意添加,防止后期难以维护

const EmptyLayout = {
  name: 'EmptyLayout',
  render() {
    return <router-view></router-view>;
  },
};

export const pageRoutes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: 'baseModule' */ '../layouts/Permission.vue'),
    children: [
      // 工作台
      // {
      //   path: 'staging/staging/staging',
      //   name: 'stagingList',
      //   component: () =>
      //     import(/* webpackChunkName: 'stagingList' */ '../views/staging/staging/staging.vue'),
      //   meta: {
      //     pageTitle: '工作台',
      //     auth: 'dashboard',
      //   },
      // },
      /** ***************************************订单管理****************************************** */
      //  订单管理 充电订单 实时订单
      {
        path: '/orderManagement/realTimeOrder/List',
        name: 'realTimeOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'realTimeOrderList' */ '../views/orderManagement/realTimeOrder/List.vue'
          ),
        meta: {
          pageTitle: '实时订单',
          auth: 'order:charge:realtime',
        },
      },
      //  订单管理 充电订单 实时订单详情
      {
        path: '/orderManagement/realTimeOrder/Detail',
        name: 'realTimeOrderDetail',
        component: () =>
          import(
            /* webpackChunkName: 'realTimeOrderDetail' */ '../views/orderManagement/realTimeOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '实时订单详情',
          auth: 'order:charge:realtime:detail',
        },
      },
      //  订单管理 充电订单 历史订单
      {
        path: '/orderManagement/historicalOrder/List',
        name: 'historicalOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'historicalOrderList' */ '../views/orderManagement/historicalOrder/List.vue'
          ),
        meta: {
          pageTitle: '历史订单',
          auth: 'order:charge:his',
        },
      },
      //  订单管理 充电订单 历史订单详情
      {
        path: '/orderManagement/historicalOrder/Detail',
        name: 'historicalOrderDetail',
        component: () =>
          import(
            /* webpackChunkName: 'historicalOrderDetail' */ '../views/orderManagement/historicalOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '历史订单详情',
          auth: 'order:charge:his:detail',
        },
      },
      //  订单管理 充电订单 充电未支付订单
      {
        path: '/orderManagement/nonPaymentOrder/List',
        name: 'chargeUnpaidList',
        component: () =>
          import(
            /* webpackChunkName: 'chargeUnpaidList' */ '../views/orderManagement/nonPaymentOrder/List.vue'
          ),
        meta: {
          pageTitle: '充电未支付订单',
          auth: 'order:charge:nopay',
        },
      },
      //  订单管理 充电订单 充电未支付订单详情
      {
        path: '/orderManagement/chargeUnpaid/Detail',
        name: 'chargeUnpaidDetail',
        component: () =>
          import(
            /* webpackChunkName: 'chargeUnpaidDetail' */ '../views/orderManagement/nonPaymentOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '充电未支付订单详情',
          auth: 'order:charge:his:detail',
        },
      },
      //  订单管理 充电订单 异常订单列表
      {
        path: '/orderManagement/abnormalOrder/List',
        name: 'abnormalOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'abnormalOrderList' */ '../views/orderManagement/abnormalOrder/List.vue'
          ),
        meta: {
          pageTitle: '异常订单',
          auth: 'order:charge:exception',
        },
      },
      //  订单管理 充电订单 异常订单详情
      {
        path: '/orderManagement/abnormalOrder/Detail',
        name: 'abnormalOrderDetail',
        component: () =>
          import(
            /* webpackChunkName: 'abnormalOrderDetail' */ '../views/orderManagement/abnormalOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '异常订单详情',
          auth: 'order:charge:exception:detail',
        },
      },
      //  订单管理 充电订单 启动失败订单
      {
        path: '/orderManagement/startFailOrder/List',
        name: 'startFailOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'startFailOrderList' */ '../views/orderManagement/startFailOrder/List.vue'
          ),
        meta: {
          pageTitle: '启动失败订单',
          auth: 'order:charge:startfail',
        },
      },
      //  订单管理 占位订单 占位订单
      {
        path: '/orderManagement/placeholderOrder/List',
        name: 'placeholderOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'placeholderOrderList' */ '../views/orderManagement/placeholderOrder/List.vue'
          ),
        meta: {
          pageTitle: '占位订单',
          auth: 'order:paceholder:list',
        },
      },
      //  订单管理 占位订单 占位订单详情
      {
        path: '/orderManagement/placeholderOrder/Detail',
        name: 'placeholderOrderDetail',
        component: () =>
          import(
            /* webpackChunkName: 'placeholderOrderDetail' */ '../views/orderManagement/placeholderOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '占位订单详情',
          auth: 'order:paceholder:detail',
        },
      },
      // 订单管理 预约订单 预约订单
      {
        path: '/orderManagement/subscribeOrder/List',
        name: 'subscribeOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'subscribeOrderList' */ '../views/orderManagement/subscribeOrder/List.vue'
          ),
        meta: {
          pageTitle: '预约订单',
          auth: 'order:subscribe:list',
        },
      },
      // 订单管理 调整单管理 调整订单
      {
        path: '/orderManagement/adjustOrder/List',
        name: 'adjustOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'adjustOrderList' */ '../views/orderManagement/adjustOrder/List.vue'
          ),
        meta: {
          pageTitle: '调整订单',
          auth: 'order:adjust:list',
        },
      },
      // 订单管理 调整单管理 调整订单详情
      {
        path: '/orderManagement/adjustOrder/Detail',
        name: 'adjustOrderDetail',
        component: () =>
          import(
            /* webpackChunkName: 'adjustOrderDetail' */ '../views/orderManagement/adjustOrder/Detail.vue'
          ),
        meta: {
          pageTitle: '调整订单详情',
          auth: 'order:adjust:list:detail',
        },
      },
      // 订单管理 互联互通订单明细 互联电卡
      {
        path: '/orderManagement/interConnected/list',
        name: 'interConnectedList',
        component: () =>
          import(
            /* webpackChunkName: 'interConnectedList' */ '../views/orderManagement/interConnected/List.vue'
          ),
        meta: {
          pageTitle: '互联电卡订单明细',
          auth: 'order:orderManagement:interConnected',
        },
      },
      // 订单管理 互联互通订单明细 平安好车主账单明细
      {
        path: '/orderManagement/pinganOrder/list',
        name: 'pinganOrderList',
        component: () =>
          import(
            /* webpackChunkName: 'pinganOrderList' */ '../views/orderManagement/pinganOrder/List.vue'
          ),
        meta: {
          pageTitle: '平安好车主账单明细',
          auth: 'order:orderManagement:pinganOrder',
        },
      },
      /** ***************************************财务管理****************************************** */
      //  财务管理 C端司机 个人收款单管理
      {
        path: 'financialManagement/accountManagement/cSideDriverAccounts',
        name: 'CSideDriverAccounts',
        component: () =>
          import(
            /* webpackChunkName: 'CSideDriverAccounts' */ '../views/financialManagement/accountManagement/cSideDriverAccount/CSideDriverAccounts.vue'
          ),
        meta: {
          pageTitle: '个人收款单管理',
          auth: 'finance:account:cacc',
        },
      },
      //  财务管理 C端司机 个人退款单管理
      {
        path: 'financialManagement/accountManagement/Crefund',
        name: 'Crefund',
        component: () =>
          import(
            /* webpackChunkName: 'Crefund' */ '../views/financialManagement/accountManagement/cSideDriverAccount/Crefund.vue'
          ),
        meta: {
          pageTitle: '个人退款单管理',
          auth: 'finance:account:refund',
        },
      },
      //  财务管理 C端司机账户-详情
      {
        path: 'financialManagement/accountManagement/cSideDriverAccountsDetail',
        name: 'CSideDriverAccountsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'CSideDriverAccountsDetail' */ '../views/financialManagement/accountManagement/cSideDriverAccount/CSideDriverAccountsDetail.vue'
          ),
        meta: {
          pageTitle: 'C端司机账户详情',
          auth: 'finance:account:cacc:detail',
        },
      },
      //  财务管理 客户账户 司机账户-列表
      {
        path: 'financialManagement/customerAccount/customDriverAccounts',
        name: 'CustomDriverAccounts',
        component: () =>
          import(
            /* webpackChunkName: 'CustomDriverAccounts' */ '../views/financialManagement/accountManagement/customerAccount/CustomDriverAccounts.vue'
          ),
        meta: {
          pageTitle: '司机账户',
          auth: 'finance:account:driver',
        },
      },
      //  财务管理 客户账户 司机账户-详情
      {
        path: 'financialManagement/customerAccount/customDriverAccountsDetail',
        name: 'CustomDriverAccountsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'CustomDriverAccountsDetail' */ '../views/financialManagement/accountManagement/customerAccount/CustomDriverAccountsDetail.vue'
          ),
        meta: {
          pageTitle: '司机账户详情',
          auth: 'finance:account:driver:detail',
        },
      },
      //  财务管理 客户账户 客户账户列表
      {
        path: 'financialManagement/customerAccount/customerAccounts',
        name: 'CustomerAccounts',
        component: () =>
          import(
            /* webpackChunkName: 'CustomerAccounts' */ '../views/financialManagement/accountManagement/customerAccount/CustomerAccounts.vue'
          ),
        meta: {
          pageTitle: '客户账户',
          auth: 'finance:account:cus',
        },
      },
      //  财务管理 客户账户 客户账户-详情
      {
        path: 'financialManagement/customerAccount/customerAccountsDetail',
        name: 'CustomerAccountsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'CustomerAccountsDetail' */ '../views/financialManagement/accountManagement/customerAccount/CustomerAccountsDetail.vue'
          ),
        meta: {
          pageTitle: '客户账户详情',
          auth: 'finance:account:cus:detail',
        },
      },
      //  财务管理 互联互通账户 互联互通账户
      {
        path: 'financialManagement/interconnectedAccount/interconnectedAccounts',
        name: 'InterconnectedAccounts',
        component: () =>
          import(
            /* webpackChunkName: 'InterconnectedAccounts' */ '../views/financialManagement/accountManagement/interconnectedAccount/InterconnectedAccounts.vue'
          ),
        meta: {
          pageTitle: '互联互通账户',
          auth: 'finance:account:inters',
        },
      },
      //  财务管理 互联互通账户 互联互通账户详情
      {
        path: 'financialManagement/interconnectedAccount/interconnectedAccountsDetail',
        name: 'InterconnectedAccountsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'InterconnectedAccountsDetail' */ '../views/financialManagement/accountManagement/interconnectedAccount/InterconnectedAccountsDetail.vue'
          ),
        meta: {
          pageTitle: '互联互通账户详情',
          auth: 'finance:account:inter:detail',
        },
      },

      //  财务管理 对账管理 平台收支账单
      {
        path: 'financialManagement/platformReceiptsPaymentsStatement/platformReceiptsPaymentsStatements',
        name: 'PlatformReceiptsPaymentsStatements',
        component: () =>
          import(
            /* webpackChunkName: 'PlatformReceiptsPaymentsStatements' */ '../views/financialManagement/accountReconciliationManagement/platformReceiptsPaymentsStatement/PlatformReceiptsPaymentsStatements.vue'
          ),
        meta: {
          pageTitle: '平台收支账单',
          auth: 'finance:reconci:platform',
        },
      },
      //  财务管理 对账管理 平台收支账单明细
      {
        path: 'financialManagement/platformReceiptsPaymentsStatement/platformReceiptsPaymentsStatementsDetail',
        name: 'PlatformReceiptsPaymentsStatementsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'PlatformReceiptsPaymentsStatementsDetail' */ '../views/financialManagement/accountReconciliationManagement/platformReceiptsPaymentsStatement/PlatformReceiptsPaymentsStatementsDetail.vue'
          ),
        meta: {
          pageTitle: '平台收支账单明细',
          auth: 'finance:reconci:platform:detail',
        },
      },
      //  财务管理 对账管理 互联互通账单
      {
        path: 'financialManagement/interconnectedBillingStatement/interconnectedBillingStatements',
        name: 'InterconnectedBillingStatements',
        component: () =>
          import(
            /* webpackChunkName: 'InterconnectedBillingStatements' */ '../views/financialManagement/accountReconciliationManagement/interconnectedBillingStatement/InterconnectedBillingStatements.vue'
          ),
        meta: {
          pageTitle: '互联互通账单',
          auth: 'finance:reconci:inter',
        },
      },
      //  财务管理 对账管理 互联互通账单明细
      {
        path: 'financialManagement/interconnectedBillingStatement/interconnectedBillingStatementsDetail',
        name: 'InterconnectedBillingStatementsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'InterconnectedBillingStatementsDetail' */ '../views/financialManagement/accountReconciliationManagement/interconnectedBillingStatement/InterconnectedBillingStatementsDetail.vue'
          ),
        meta: {
          pageTitle: '互联互通账单明细',
          auth: 'finance:reconci:inter:detail',
        },
      },
      //  财务管理 对账管理 商户账单
      {
        path: 'financialManagement/merchantStatement/merchantStatements',
        name: 'MerchantStatements',
        component: () =>
          import(
            /* webpackChunkName: 'MerchantStatements' */ '../views/financialManagement/accountReconciliationManagement/merchantStatement/MerchantStatements.vue'
          ),
        meta: {
          pageTitle: '商户账单',
          auth: 'finance:reconci:merchant',
        },
      },
      //  财务管理 对账管理 商户账单明细
      {
        path: 'financialManagement/merchantStatement/merchantStatementsDetail',
        name: 'MerchantStatementsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'MerchantStatementsDetail' */ '../views/financialManagement/accountReconciliationManagement/merchantStatement/MerchantStatementsDetail.vue'
          ),
        meta: {
          pageTitle: '商户账单明细',
          auth: 'finance:reconci:merchant:detail',
        },
      },
      //  财务管理 对账管理 占位费收支账单
      {
        path: 'financialManagement/occupancyFeeReceiptsPayments/occupancyFeeReceiptsPayments',
        name: 'OccupancyFeeReceiptsPayments',
        component: () =>
          import(
            /* webpackChunkName: 'OccupancyFeeReceiptsPayments' */ '../views/financialManagement/accountReconciliationManagement/occupancyFeeReceiptsPayments/OccupancyFeeReceiptsPayments.vue'
          ),
        meta: {
          pageTitle: '占位费收支账单',
          auth: 'finance:reconci:place',
        },
      },
      //  财务管理 对账管理 占位费收支账单详情
      {
        path: 'financialManagement/occupancyFeeReceiptsPayments/occupancyFeeReceiptsPaymentsDetail',
        name: 'OccupancyFeeReceiptsPaymentsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'OccupancyFeeReceiptsPaymentsDetail' */ '../views/financialManagement/accountReconciliationManagement/occupancyFeeReceiptsPayments/OccupancyFeeReceiptsPaymentsDetail.vue'
          ),
        meta: {
          pageTitle: '占位费收支账单明细',
          auth: 'finance:reconci:place:detail',
        },
      },
      //  财务管理 对账管理 客户账单
      {
        path: 'financialManagement/customerStatement/customerStatements',
        name: 'CustomerStatements',
        component: () =>
          import(
            /* webpackChunkName: 'CustomerStatements' */ '../views/financialManagement/accountReconciliationManagement/customerStatement/CustomerStatements.vue'
          ),
        meta: {
          pageTitle: '客户账单',
          auth: 'finance:reconci:cus:sub',
        },
      },
      //  财务管理 对账管理 客户账单 客户账单明细
      {
        path: 'financialManagement/customerStatement/customerStatementsDetail',
        name: 'CustomerStatementsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'CustomerStatementsDetail' */ '../views/financialManagement/accountReconciliationManagement/customerStatement/CustomerStatementsDetail.vue'
          ),
        meta: {
          pageTitle: '客户账单明细',
          auth: 'finance:reconci:cus:sub:detail',
        },
      },
      //  财务管理 对账管理 客户账单 子机构账单
      {
        path: 'financialManagement/subAgencyBill/subAgencyBill',
        name: 'SubAgencyBill',
        component: () =>
          import(
            /* webpackChunkName: 'SubAgencyBill' */ '../views/financialManagement/accountReconciliationManagement/customerStatement/subAgencyBill/SubAgencyBill.vue'
          ),
        meta: {
          pageTitle: '子机构账单',
          auth: 'finance:reconci:cus:sub',
        },
      },
      //  财务管理 对账管理 客户账单 子机构账单明细
      {
        path: 'financialManagement/subAgencyBill/subAgencyBillDetail',
        name: 'SubAgencyBillDetail',
        component: () =>
          import(
            /* webpackChunkName: 'SubAgencyBillDetail' */ '../views/financialManagement/accountReconciliationManagement/customerStatement/subAgencyBill/SubAgencyBillDetail.vue'
          ),
        meta: {
          pageTitle: '子机构账单明细',
          auth: 'finance:reconci:cus:sub:detail',
        },
      },
      //  财务管理 对账管理 付费会员收支账单
      {
        path: 'financialManagement/feeMemberBill/feeMemberBill',
        name: 'FeeMemberBill',
        component: () =>
          import(
            /* webpackChunkName: 'FeeMemberBill' */ '../views/financialManagement/accountReconciliationManagement/feeMemberBill/List.vue'
          ),
        meta: {
          pageTitle: '付费会员收支账单',
          auth: 'finance:feeMember:bill',
        },
      },
      {
        path: 'financialManagement/feeMemberBill/feeMemberBillDetail',
        name: 'FeeMemberBillDetail',
        component: () =>
          import(
            /* webpackChunkName: 'FeeMemberBill' */ '../views/financialManagement/accountReconciliationManagement/feeMemberBill/Detail.vue'
          ),
        meta: {
          pageTitle: '付费会员账单明细',
          auth: 'finance:feeMember:bill',
        },
      },
      //  财务管理 发票管理 平台发票管理
      {
        path: 'financialManagement/invoiceManagement/InvoiceManagements',
        name: 'InvoiceManagements',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceManagements' */ '../views/financialManagement/invoiceManagement/InvoiceManagements.vue'
          ),
        meta: {
          pageTitle: '平台发票管理',
          auth: 'finance:invoices',
        },
      },
      //  财务管理 发票管理 开票处理
      {
        path: 'financialManagement/invoiceManagement/invoiceIssuingProcessing',
        name: 'InvoiceIssuingProcessing',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceIssuingProcessing' */ '../views/financialManagement/invoiceManagement/InvoiceIssuingProcessing.vue'
          ),
        meta: {
          pageTitle: '开票处理',
          auth: 'finance:invoice:make',
        },
      },

      //  财务管理 发票管理 发票详情（已开票）
      {
        path: 'financialManagement/invoiceManagement/invoiceDetailsIssued',
        name: 'InvoiceDetailsIssued',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceDetailsIssued' */ '../views/financialManagement/invoiceManagement/InvoiceDetailsIssued.vue'
          ),
        meta: {
          pageTitle: '发票管理详情',
          auth: 'finance:invoice:detail',
        },
      },
      //  财务管理 发票管理 已退回
      {
        path: 'financialManagement/invoiceManagement/invoiceDetailsReturned',
        name: 'InvoiceDetailsReturned',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceDetailsReturned' */ '../views/financialManagement/invoiceManagement/InvoiceDetailsReturned.vue'
          ),
        meta: {
          pageTitle: '发票管理-已退回',
          auth: 'finance:invoice:detail',
        },
      },
      //  财务管理 发票管理 待开票
      {
        path: 'financialManagement/invoiceManagement/invoiceDetailsToBeIssued',
        name: 'InvoiceDetailsToBeIssued',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceDetailsToBeIssued' */ '../views/financialManagement/invoiceManagement/InvoiceDetailsToBeIssued.vue'
          ),
        meta: {
          pageTitle: '发票管理详情',
          auth: 'finance:invoice:detail',
        },
      },
      //  财务管理 发票管理 已驳回
      {
        path: 'financialManagement/invoiceManagement/invoiceDetailsRejected',
        name: 'InvoiceDetailsRejected',
        component: () =>
          import(
            /* webpackChunkName: 'InvoiceDetailsRejected' */ '../views/financialManagement/invoiceManagement/InvoiceDetailsRejected.vue'
          ),
        meta: {
          pageTitle: '发票管理详情',
          auth: 'finance:invoice:detail',
        },
      },
      // 财务管理 充值退款管理 充值退款记录
      {
        path: 'dataStatistics/platformStatistics/amountDetailStatistics/List',
        name: 'amountDetailStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'amountDetailStatisticsList' */ '../views/financialManagement/amountDetailStatistics/List.vue'
          ),
        meta: {
          pageTitle: '充值退款统计',
          auth: 'finance:recharge:list',
        },
      },
      /** ***************************************数据统计****************************************** */
      // 数据统计 运营数据统计 时期统计
      {
        path: 'dataStatistics/operationStatistics/periodStatistics/List',
        name: 'periodStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'periodStatisticsList' */ '../views/dataStatistics/operationStatistics/periodStatistics/List.vue'
          ),
        meta: {
          pageTitle: '时期统计',
          auth: 'data:platform:period',
        },
      },
      // 数据统计 运营数据统计 小时统计
      {
        path: 'dataStatistics/operationStatistics/hourStatistics/List',
        name: 'hourStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'hourStatisticsList' */ '../views/dataStatistics/operationStatistics/hourStatistics/List.vue'
          ),
        meta: {
          pageTitle: '小时统计',
          auth: 'data:platform:hours',
        },
      },
      // 数据统计 运营数据统计 流水统计
      {
        path: 'dataStatistics/operationStatistics/flowStatistics/List',
        name: 'flowStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'flowStatisticsList' */ '../views/dataStatistics/operationStatistics/flowStatistics/List.vue'
          ),
        meta: {
          pageTitle: '流水统计',
          auth: 'data:platform:flow',
        },
      },
      // 数据统计 运营数据统计 流水统计-详情
      {
        path: 'dataStatistics/operationStatistics/flowStatistics/detail',
        name: 'flowStatisticsDetail',
        component: () =>
          import(
            /* webpackChunkName: 'flowStatisticsDetail' */ '../views/dataStatistics/operationStatistics/flowStatistics/Detail.vue'
          ),
        meta: {
          pageTitle: '流水详情',
          auth: 'finance:account:cacc:detail',
        },
      },
      // 数据统计 充电数据统计 电站统计
      {
        path: 'dataStatistics/chargingStatistics/powerstationStatistics/List',
        name: 'powerstationStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'powerstationStatisticsList' */ '../views/dataStatistics/chargingStatistics/powerstationStatistics/List.vue'
          ),
        meta: {
          pageTitle: '电站统计',
          auth: 'data:charge:station',
        },
      },
      // 数据统计 充电数据统计 终端统计
      {
        path: 'dataStatistics/chargingStatistics/terminalStatistics/List',
        name: 'terminalStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'terminalStatisticsList' */ '../views/dataStatistics/chargingStatistics/terminalStatistics/List.vue'
          ),
        meta: {
          pageTitle: '终端统计',
          auth: 'data:charge:terminal',
        },
      },
      // 数据统计 充电数据统计 商户统计
      {
        path: 'dataStatistics/chargingStatistics/merchantStatistics/List',
        name: 'merchantStatisticsList',
        component: () =>
          import(
            /* webpackChunkName: 'merchantStatisticsList' */ '../views/dataStatistics/chargingStatistics/merchantStatistics/List.vue'
          ),
        meta: {
          pageTitle: '商户统计',
          auth: 'data:charge:merchant',
        },
      },
      /** ***************************************电站设备****************************************** */
      //  电站设备 电站管理 直联电站
      {
        path: 'plantAssets/powerStationManagement/directConnectionStation/List',
        name: 'directConnectionStationList',
        component: () =>
          import(
            /* webpackChunkName: 'directConnectionStationList' */ '../views/plantAssets/powerStationManagement/directConnectionStation/List.vue'
          ),
        meta: {
          pageTitle: '直联电站',
          auth: 'asset:station:direct',
        },
      },
      //  电站设备 电站管理 直联电站详情
      {
        path: 'plantAssets/powerStationManagement/directConnectionStation/Detail',
        name: 'directConnectionStationDetail',
        component: () =>
          import(
            /* webpackChunkName: 'directConnectionStationDetail' */ '../views/plantAssets/powerStationManagement/directConnectionStation/Detail.vue'
          ),
        meta: {
          pageTitle: '直联电站详情',
          auth: 'asset:station:direct:detail',
        },
      },
      //  电站设备 电站管理 操作记录
      {
        path: 'plantAssets/powerStationManagement/directConnectionStation/record',
        name: 'directConnectionStationRecord',
        component: () =>
          import(
            /* webpackChunkName: 'directConnectionStationDetail' */ '../views/plantAssets/powerStationManagement/directConnectionStation/Record.vue'
          ),
        meta: {
          pageTitle: '操作记录',
          auth: 'asset:station:direct:detail',
        },
      },

      //  电站设备 电站管理 互联电站
      // {
      //   path: 'plantAssets/powerStationManagement/interconnectionStation/List',
      //   name: 'interconnectionStationList',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'interconnectionStationList' */ '../views/plantAssets/powerStationManagement/interconnectionStation/List.vue'
      //     ),
      //   meta: {
      //     pageTitle: '互联电站',
      //     auth: 'asset:station:connection',
      //   },
      // },
      //  电站设备 电站管理 互联电站详情
      {
        path: 'plantAssets/powerStationManagement/interconnectionStation/Detail',
        name: 'interconnectionStationDetail2',
        component: () =>
          import(
            /* webpackChunkName: 'interconnectionStationDetail' */ '../views/plantAssets/powerStationManagement/interconnectionStation/Detail.vue'
          ),
        meta: {
          pageTitle: '互联电站详情',
          auth: 'asset:station:connection:detail',
        },
      },
      //  电站设备 电桩管理 直联电桩
      {
        path: 'plantAssets/powerPileManagement/directConnectionPile/List',
        name: 'directConnectionPileList',
        component: () =>
          import(
            /* webpackChunkName: 'directConnectionPileList' */ '../views/plantAssets/powerPileManagement/directConnectionPile/List.vue'
          ),
        meta: {
          pageTitle: '直联电桩',
          auth: 'asset:station:diretpile',
        },
      },
      //  电站设备 电桩管理 直连终端
      {
        path: 'plantAssets/powerPileManagement/directConnectTerminal/List',
        name: 'directConnectTerminalList',
        component: () =>
          import(
            /* webpackChunkName: 'directConnectTerminalList' */ '../views/plantAssets/powerPileManagement/directConnectTerminal/List.vue'
          ),
        meta: {
          pageTitle: '直联终端',
          auth: 'asset:station:erminal',
        },
      },
      //  电站设备 电桩管理 互联电桩
      // {
      //   path: 'plantAssets/powerPileManagement/interconnectionPile/List',
      //   name: 'interconnectionPileList',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'directConnectionPileList' */ '../views/plantAssets/powerPileManagement/interconnectionPile/List.vue'
      //     ),
      //   meta: {
      //     pageTitle: '互联电桩',
      //     auth: 'asset:station:conpile',
      //   },
      // },
      //  电站设备 电桩品牌型号 电桩品牌型号列表
      {
        path: 'plantAssets/brandAndModel/List',
        name: 'brandAndModelList',
        component: () =>
          import(
            /* webpackChunkName: 'brandAndModelList' */ '../views/plantAssets/brandAndModel/List.vue'
          ),
        meta: {
          pageTitle: '品牌型号',
          auth: 'asset:station:brand',
        },
      },
      //  电站设备 报文查询 报文列表
      {
        path: '/plantAssets/messageQuery/List',
        name: 'messageQueryList',
        component: () =>
          import(
            /* webpackChunkName: 'messageQueryList' */ '../views/plantAssets/messageQuery/pileProtocol/List.vue'
          ),
        meta: {
          pageTitle: '报文查询',
          auth: 'asset:station:messageQuery',
        },
      },
      // {
      //   path: 'plantAssets/messageQuery/pileProtocol/List',
      //   name: 'pileProtocolList',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'pileProtocolList' */ '../views/plantAssets/messageQuery/pileProtocol/List.vue'
      //     ),
      //   meta: {
      //     pageTitle: '电桩报文',
      //     auth: 'asset:station:brand',
      //   },
      // },
      //  电站设备 实时监控 车位监控管理
      {
        path: '/plantAssets/parkMonitor/List',
        name: 'parkMonitorList',
        component: () =>
          import(
            /* webpackChunkName: 'parkMonitorList' */ '../views/plantAssets/parkMonitor/List.vue'
          ),
        meta: {
          pageTitle: '车位监控管理',
          auth: 'asset:stationfacility:parkmonitor',
        },
      },
      //  电站设备 场站外设备 道闸列表
      {
        path: '/plantAssets/offSite/barrierGate/List',
        name: 'barrierGateList',
        component: () =>
          import(
            /* webpackChunkName: 'barrierGateList' */ '../views/plantAssets/offSite/barrierGate/List.vue'
          ),
        meta: {
          pageTitle: '道闸列表',
          auth: 'asset:barrier:list',
        },
      },
      //  电站设备 场站外设备 道闸详情
      {
        path: '/plantAssets/offSite/barrierGate/Detail',
        name: 'barrierGateDetail',
        component: () =>
          import(
            /* webpackChunkName: 'barrierGateDetail' */ '../views/plantAssets/offSite/barrierGate/Detail.vue'
          ),
        meta: {
          pageTitle: '道闸详情',
          auth: 'asset:barrier:detail',
        },
      },
      //  电站设备 场站外设备 道闸减免记录
      {
        path: '/plantAssets/offSite/barrierGate/recordList',
        name: 'barrierRecordList',
        component: () =>
          import(
            /* webpackChunkName: 'barrierRecordList' */ '../views/plantAssets/offSite/recordList/List.vue'
          ),
        meta: {
          pageTitle: '道闸减免记录',
          auth: 'asset:barrier:record',
        },
      },
      //  电站设备 场站外设备 广告大屏
      {
        path: '/plantAssets/advertising/List',
        name: 'advertisingDisplayScreenList',
        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/offSite/advertisingDisplayScreen/List.vue'
          ),
        meta: {
          pageTitle: '广告大屏',
          auth: 'asset:stationfacility:advertising',
        },
      },
      //  电站设备 实时监控 车位监控
      {
        path: '/plantAssets/realParkMonitor/List',
        name: 'realParkMonitorList',

        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/realParkMonitor/List.vue'
          ),
        meta: {
          pageTitle: '实时监控',
          auth: 'asset:realtimemonitor:parkmon',
        },
      },
      //  电站设备 实时监控 车位监控 车位划线
      {
        path: '/plantAssets/realParkMonitor/line',
        name: 'realParkMonitorLine',
        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/realParkMonitor/Line.vue'
          ),
        meta: {
          pageTitle: '车位划线',
          auth: 'asset:realtimemonitor:parkmon:line',
        },
      },
      //  电站设备 实时监控 车位监控 摄像头车位标注
      {
        path: '/plantAssets/realParkMonitor/draw',
        name: 'realParkMonitorDraw',
        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/realParkMonitor/Draw.vue'
          ),
        meta: {
          pageTitle: '摄像头车位标注',
          auth: 'asset:realtimemonitor:parkmon:labelcoord',
        },
      },
      //  电站设备 实时监控 充电桩监控
      {
        path: '/plantAssets/chargingPile/List',
        name: 'chargingPile',
        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/chargingPile/List.vue'
          ),
        meta: {
          pageTitle: '充电桩监控',
          auth: 'asset:station:brand',
        },
      },
      //  电站设备 实时监控 广告屏监控
      {
        path: '/plantAssets/advertisingMonitor/List',
        name: 'advertisingMonitor',
        component: () =>
          import(
            /* webpackChunkName: 'advertisingDisplayScreenList' */ '../views/plantAssets/advertisingMonitor/List.vue'
          ),
        meta: {
          pageTitle: '广告屏监控',
          auth: 'asset:station:brand',
        },
      },
      //  电站设备 OTA远程升级 升级包管理
      {
        path: '/plantAssets/upgrade/package/List',
        name: 'plantAssetsUpgradePackageList',
        component: () =>
          import(
            /* webpackChunkName: 'plantAssetsUpgradePackageList' */ '../views/plantAssets/upgrade/package/List.vue'
          ),
        meta: {
          pageTitle: '升级包管理',
          auth: 'device:ota:package:page',
        },
      },
      //  电站设备 OTA远程升级 升级包详情
      {
        path: '/plantAssets/upgrade/package/Detail',
        name: 'plantAssetsUpgradePackageDetail',
        component: () =>
          import(
            /* webpackChunkName: 'plantAssetsUpgradePackageList' */ '../views/plantAssets/upgrade/package/Detail.vue'
          ),
        meta: {
          pageTitle: '升级包详情',
          auth: 'device:ota:package:detail',
        },
      },
      //  电站设备 OTA远程升级
      {
        path: '/plantAssets/upgrade/task/List',
        name: 'plantAssetsUpgradeTaskList',
        component: () =>
          import(
            /* webpackChunkName: 'plantAssetsUpgradePackageList' */ '../views/plantAssets/upgrade/task/List.vue'
          ),
        meta: {
          pageTitle: 'OTA升级',
          auth: 'device:ota:task:page',
        },
      },
      //  电站设备 OTA远程升级 升级包详情
      {
        path: '/plantAssets/upgrade/task/Detail',
        name: 'plantAssetsUpgradeTaskDetail',
        component: () =>
          import(
            /* webpackChunkName: 'plantAssetsUpgradePackageList' */ '../views/plantAssets/upgrade/task/Detail.vue'
          ),
        meta: {
          pageTitle: 'OTA升级详情页',
          auth: 'device:ota:task:detail',
        },
      },
      /** ***************************************运营管理****************************************** */
      // 运营管理 充电计费信息 充电价格策略
      {
        path: '/operationCenter/priceManage/chargingPriceStrategy',
        name: 'chargingPriceStrategyList',
        component: () =>
          import('../views/operationCenter/priceManage/chargingPriceStrategy/List.vue'),
        meta: {
          pageTitle: '充电价格策略',
          auth: 'operation:price:charge',
        },
      },
      {
        path: '/operationCenter/priceManage/chargingPriceStrategy/details',
        name: 'chargingPriceStrategyDetail',
        component: () =>
          import('../views/operationCenter/priceManage/chargingPriceStrategy/Detail.vue'),
        meta: {
          pageTitle: '充电价格策略详情',
          auth: 'operation:price:charge:detail',
        },
      },
      // 运营管理 充电计费信息 充电价格模板
      {
        path: '/operationCenter/priceManage/chargingPriceTemplate',
        name: 'chargingPriceTemplateList',
        component: () =>
          import('../views/operationCenter/priceManage/chargingPriceTemplate/List.vue'),
        meta: {
          pageTitle: '充电价格模板',
          auth: 'operation:price:template',
        },
      },
      // 运营管理 充电计费信息 充电价格模板-详情
      {
        path: '/operationCenter/priceManage/chargingPriceTemplate/details',
        name: 'chargingPriceTemplateDetail',
        component: () =>
          import('../views/operationCenter/priceManage/chargingPriceTemplate/Detail.vue'),
        meta: {
          pageTitle: '充电价格模板详情',
          auth: 'operation:price:template:detail',
        },
      },
      // 运营管理 占位计费信息 占位价格策略
      {
        path: '/operationCenter/occupyManage/occupyingPriceStrategy',
        name: 'occupyingPriceStrategyList',
        component: () =>
          import('../views/operationCenter/occupyManage/occupyingPriceStrategy/List.vue'),
        meta: {
          pageTitle: '占位价格策略',
          auth: 'operation:place:price',
        },
      },
      // 运营管理 占位计费信息 占位价格策略详情
      {
        path: '/operationCenter/occupyManage/occupyingPriceStrategy/details',
        name: 'occupyingPriceStrategyDetail',
        component: () =>
          import('../views/operationCenter/occupyManage/occupyingPriceStrategy/Detail.vue'),
        meta: {
          pageTitle: '占位价格策略详情',
          auth: 'operation:place:price:detail',
        },
      },
      // 运营管理 占位计费信息 占位价格模版
      {
        path: '/operationCenter/occupyManage/occupyingTemplate',
        name: 'occupyingTemplateList',
        component: () => import('../views/operationCenter/occupyManage/occupyingTemplate/List.vue'),
        meta: {
          pageTitle: '占位价格模版',
          auth: 'operation:place:template',
        },
      },
      // 运营管理 占位计费信息 占位价格模版详情
      {
        path: '/operationCenter/occupyManage/occupyingTemplate/details',
        name: 'occupyingTemplateDetail',
        component: () =>
          import('../views/operationCenter/occupyManage/occupyingTemplate/Detail.vue'),
        meta: {
          pageTitle: '占位价格模版详情',
          auth: 'operation:place:template:detail',
        },
      },
      // 运营管理 占位计费策略 占位豁免策略
      {
        path: '/operationCenter/occupyManage/occupyExemptions/List',
        name: 'occupyingExemptions',
        component: () => import('../views/operationCenter/occupyManage/occupyExemptions/List.vue'),
        meta: {
          pageTitle: '占位费豁免策略',
          auth: 'operation:place:exemption',
        },
      },
      // 运营管理 占位计费策略 占位豁免策略-详情
      {
        path: '/operationCenter/occupyManage/occupyExemptions/Detail',
        name: 'occupyingExemptionsDetail',
        component: () =>
          import('../views/operationCenter/occupyManage/occupyExemptions/Detail.vue'),
        meta: {
          pageTitle: '占位费豁免策略',
          auth: 'operation:place:exemption:detail',
        },
      },
      // 运营管理 占位计费策略 占位豁免策略-新增（编辑）
      {
        path: '/operationCenter/occupyManage/occupyExemptions/AddOrEdit',
        name: 'occupyingExemptionsAddOrEdit',
        component: () =>
          import('../views/operationCenter/occupyManage/occupyExemptions/AddOrEdit.vue'),
        meta: {
          pageTitle: '占位费豁免策略',
          auth: 'operation:place:exemption:edit',
        },
      },
      // 运营管理 占位计费信息 预约策略管理
      {
        path: '/operationCenter/subscribeManage/subscribeList',
        name: 'subscribeList',
        component: () => import('../views/operationCenter/subscribeManage/subscribeList/List.vue'),
        meta: {
          pageTitle: '预约策略管理',
          auth: 'operation:subscribe:list',
        },
      },
      // 运营管理 占位计费信息 预约策略模版
      {
        path: '/operationCenter/subscribeManage/subTemplateList',
        name: 'subTemplateList',
        component: () =>
          import('../views/operationCenter/subscribeManage/subTemplateList/List.vue'),
        meta: {
          pageTitle: '预约策略模版',
          auth: 'operation:subscribe:template',
        },
      },
      // 运营管理 大客户定价
      {
        path: '/operationCenter/bigCustomerPricing/bigcustomerList',
        name: 'bigcustomerStrategyList',
        component: () => import('../views/operationCenter/bigCustomerPricing/List.vue'),
        meta: {
          pageTitle: '大客户定价',
          auth: 'operation:bigcustomer:list',
        },
      },
      // 运营管理 大客户定价-详情
      {
        path: '/operationCenter/bigCustomerPricing/bigcustomerList/details',
        name: 'bigcustomerStrategyDetail',
        component: () => import('../views/operationCenter/bigCustomerPricing/Detail.vue'),
        meta: {
          pageTitle: '大客户定价详情',
          auth: 'operation:bigcustomer:list:detail',
        },
      },
      // 运营管理 运营配置 抽成费用策略
      {
        path: '/operationCenter/operaConfigManage/royaltyStrategy',
        name: 'royaltyStrategyList',
        component: () =>
          import('../views/operationCenter/operaConfigManage/royaltyStrategy/List.vue'),
        meta: {
          pageTitle: '抽成费用策略',
          auth: 'operation:config:rake',
        },
      },
      // 运营管理 运营配置 电站SOC限制管理
      {
        path: '/operationCenter/operaConfigManage/stationSocAstrictList',
        name: 'stationSocAstrictList',
        component: () =>
          import('../views/operationCenter/operaConfigManage/stationSocAstrict/List.vue'),
        meta: {
          pageTitle: '电站SOC限制管理',
          auth: 'operation:config:stationsoc',
        },
      },
      // 运营管理 运营配置 城市SOC限制管理
      {
        path: '/operationCenter/operaConfigManage/citySocAstrictList',
        name: 'citySocAstrictList',
        component: () =>
          import('../views/operationCenter/operaConfigManage/citySocAstrict/List.vue'),
        meta: {
          pageTitle: '城市SOC限制管理',
          auth: 'operation:config:citysoc',
        },
      },
      // 运营管理 运营配置 场站黑名单
      {
        path: '/operationCenter/operaConfigManage/stationBlackList',
        name: 'stationBlackList',
        component: () => import('../views/operationCenter/operaConfigManage/stationBlack/List.vue'),
        meta: {
          pageTitle: '场站黑名单',
          auth: 'operation:config:black',
        },
      },
      // 运营管理 运营配置 场站黑名单-管理
      {
        path: '/operationCenter/operaConfigManage/stationBlackList/config',
        name: 'stationBlackUserConfg',
        component: () =>
          import('../views/operationCenter/operaConfigManage/stationBlack/userConfg.vue'),
        meta: {
          pageTitle: '黑名单管理',
          auth: 'operation:config:black:config',
        },
      },
      // 运营管理 运营配置 场站白名单
      {
        path: '/operationCenter/operaConfigManage/stationWhiteList',
        name: 'stationWhiteList',
        component: () => import('../views/operationCenter/operaConfigManage/stationWhite/List.vue'),
        meta: {
          pageTitle: '场站白名单',
          auth: 'operation:config:white',
        },
      },
      // 运营管理 运营配置 场站白名单-管理
      {
        path: '/operationCenter/operaConfigManage/stationWhiteList/config',
        name: 'stationWhiteUserConfg',
        component: () =>
          import('../views/operationCenter/operaConfigManage/stationWhite/userConfg.vue'),
        meta: {
          pageTitle: '白名单管理',
          auth: 'operation:config:white:config',
        },
      },
      // 运营管理 运营配置 企微二维码配置
      {
        path: '/operationCenter/operaConfigManage/enterpriseQRCode/List',
        name: 'enterpriseQRCodeList',
        component: () =>
          import('../views/operationCenter/operaConfigManage/enterpriseQRCode/List.vue'),
        meta: {
          pageTitle: '企微二维码配置',
          auth: 'asset:file:manage:edit',
        },
      },
      // 运营管理 运营配置 企微二维码配置-详情
      {
        path: '/operationCenter/operaConfigManage/enterpriseQRCode/Detail',
        name: 'enterpriseQRCodeDetail',
        component: () =>
          import('../views/operationCenter/operaConfigManage/enterpriseQRCode/Detail.vue'),
        meta: {
          pageTitle: '企微二维码配置',
          auth: 'asset:file:manage:edit',
        },
      },
      // 运营管理 运营配置 企微二维码配置-新增（编辑）
      {
        path: '/operationCenter/operaConfigManage/enterpriseQRCode/AddOrEdit',
        name: 'enterpriseQRCodeAddOrEdit',
        component: () =>
          import('../views/operationCenter/operaConfigManage/enterpriseQRCode/AddOrEdit.vue'),
        meta: {
          pageTitle: '企微二维码配置',
          auth: 'asset:file:manage:edit',
        },
      },
      // 运营管理 电站评价
      {
        path: '/operationCenter/stationEvaluation/List',
        name: 'stationEvaluationList',
        component: () => import('../views/operationCenter/stationEvaluation/List.vue'),
        meta: {
          pageTitle: '电站评价',
          auth: 'operation:evaluate:list',
        },
      },
      // 运营管理 电站评价-详情
      {
        path: '/operationCenter/stationEvaluation/details',
        name: 'stationEvaluationDetail',
        component: () => import('../views/operationCenter/stationEvaluation/Detail.vue'),
        meta: {
          pageTitle: '电站评价详情',
          auth: 'operation:evaluate:list:detail',
        },
      },
      // 运营管理 评论标签管理
      {
        path: '/operationCenter/stationEvaluation/LabelList',
        name: 'evaluationLabelList',
        component: () => import('../views/operationCenter/evaluationLabel/List.vue'),
        meta: {
          pageTitle: '评论标签管理',
          auth: 'operation:evaluate:label',
        },
      },
      // 运营管理 优先充电规则配置
      {
        path: '/operationCenter/chargeSetting/ruleSetting',
        name: 'chargeRuleSettingList',
        component: () => import('../views/operationCenter/chargeSetting/ruleSetting/List.vue'),
        meta: {
          pageTitle: '优先充电规则配置',
          auth: 'station:charge:priority:rule:page',
        },
      },
      // 运营管理 优先级配置
      {
        path: '/operationCenter/chargeSetting/sortSetting',
        name: 'chargeSortSettingList',
        component: () => import('../views/operationCenter/chargeSetting/sortSetting/List.vue'),
        meta: {
          pageTitle: '优先级配置',
          auth: 'station:charge:priority:page',
        },
      },
      // 运营管理 电站充电策略配置
      {
        path: '/operationCenter/chargeSetting/stationSetting',
        name: 'chargeStationSettingList',
        component: () => import('../views/operationCenter/chargeSetting/stationSetting/List.vue'),
        meta: {
          pageTitle: '电站充电策略配置',
          auth: 'station:charge:priority:config:page',
        },
      },
      /** ***************************************营销管理****************************************** */
      // 营销管理-充电折扣策略管理-充电价格活动
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity',
        name: 'platformPriceActivityList',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity/List'
          ),
        meta: {
          pageTitle: '充电价格活动',
          auth: 'marketing:platform:price',
        },
      },
      // 营销管理-充电折扣策略管理-充电价格活动-详情
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity/details',
        name: 'platformPriceActivityDetail',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity/Detail'
          ),
        meta: {
          pageTitle: '充电价格活动详情',
          auth: 'marketing:platform:price:detail',
        },
      },
      // 营销管理-充电折扣策略管理-充电价格活动-认证活动详情
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity/detailsAuth',
        name: 'platformPriceActivityDetailAuth',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformPriceActivity/DetailAuth'
          ),
        meta: {
          pageTitle: '认证定价活动详情',
          auth: 'marketing:platform:price:detail',
        },
      },
      // 营销管理-活动中心-积分兑换记录
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/platformIntegralExchangeRecord',
        name: 'platformIntegralExchangeRecordList',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformIntegralExchangeRecord/List'
          ),
        meta: {
          pageTitle: '积分兑换记录',
          auth: 'marketing:platform:exchange',
        },
      },
      // 营销管理-活动中心-卡券活动中心
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/platformCouponActivity',
        name: 'platformCouponActivityList',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformCouponActivity/List'
          ),
        meta: {
          pageTitle: '卡券活动中心',
          auth: 'marketing:platform:card',
        },
      },
      // 营销管理-活动中心-卡券活动中心-记录
      {
        path: '/marketingCenter/platformMarketingTools/marketingActivity/pickUpRecord',
        name: 'platformCouponActivityPickUpRecord',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformCouponActivity/PickUpRecord'
          ),
        meta: {
          pageTitle: '活动中心记录',
          auth: 'marketing:platform:card:record',
        },
      },
      // 营销管理-活动中心-卡券活动中心-详情
      {
        path: '/marketingCenter/details',
        name: 'detail',
        component: () =>
          import(
            '../views/marketingCenter/platformMarketingTools/marketingActivity/platformCouponActivity/Detail'
          ),
        meta: {
          pageTitle: '活动中心详情',
          auth: 'marketing:platform:card:detail',
        },
      },
      // 营销管理-卡券中心-卡券使用配置
      {
        path: '/marketingCenter/platformMarketingTools/useConfig',
        name: 'useConfigList',
        component: () =>
          import(
            /* webpackChunkName: 'useConfig' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/useConfig/useConfig'
          ),
        meta: {
          pageTitle: '卡券使用配置',
          auth: 'marketing:platcard:useConfig',
        },
      },
      // 营销管理-卡券中心-抵用卡管理
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard',
        name: 'platformCreditCardList',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/creditCard/List'
          ),
        meta: {
          pageTitle: '抵用卡管理',
          auth: 'marketing:platform:debit',
        },
      },
      // 营销管理-卡券中心-抵用卡管理-抵用卡明细
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard/particulars',
        name: 'platformCreditCardParticulars',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/creditCard/Particulars'
          ),
        meta: {
          pageTitle: '抵用卡明细',
          auth: 'marketing:platform:debit:data',
        },
      },
      // 营销管理-卡券中心-抵用卡管理-抵用卡详情
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard/details',
        name: 'platformCreditCardDetail',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/creditCard/Detail'
          ),
        meta: {
          pageTitle: '抵用卡详情',
          auth: 'marketing:platform:debit:detail',
        },
      },
      // 营销管理-卡券中心-优惠券管理
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon',
        name: 'platformCouponList',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/coupon/List'
          ),
        meta: {
          pageTitle: '优惠券管理',
          auth: 'marketing:platform:coupon',
        },
      },
      // 营销管理-卡券中心-优惠券管理-优惠券明细
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon/particulars',
        name: 'platformCouponParticulars',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/coupon/Particulars'
          ),
        meta: {
          pageTitle: '优惠券明细',
          auth: 'marketing:platform:coupon:data',
        },
      },
      // 营销管理-卡券中心-优惠券管理-优惠券详情
      {
        path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon/details',
        name: 'platformCouponDetail',
        component: () =>
          import(
            /* webpackChunkName: 'platformMarketingTools' */ '../views/marketingCenter/platformMarketingTools/platformCoupon/coupon/Detail'
          ),
        meta: {
          pageTitle: '优惠券详情',
          auth: 'marketing:platform:coupon:detail',
        },
      },
      // 营销管理 商户营销活动 商户价格活动
      {
        path: '/marketingCenter/merchantMarketingTools/marketingActivity/merchantPriceActivity',
        name: 'merchantPriceActivityList',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/marketingActivity/merchantPriceActivity/List'
          ),
        meta: {
          pageTitle: '商户价格活动',
          auth: 'marketing:mcampaign:price',
        },
      },
      // 营销管理 商户营销活动 商户价格活动详情
      {
        path: '/marketingCenter/merchantMarketingTools/marketingActivity/merchantPriceActivity/detail',
        name: 'merchantPriceActivityDetail',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/marketingActivity/merchantPriceActivity/Detail'
          ),
        meta: {
          pageTitle: '商户价格活动详情',
          auth: 'marketing:mcampaign:price:detail',
        },
      },
      // 营销管理 商户营销活动 商户卡券活动
      {
        path: '/marketingCenter/merchantMarketingTools/marketingActivity/merchantCouponActivity',
        name: 'merchantCouponActivityList',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/marketingActivity/merchantCouponActivity/List'
          ),
        meta: {
          pageTitle: '商户卡券活动',
          auth: 'marketing:mcampaign:coupon',
        },
      },
      // 营销管理 商户营销活动 商户卡券活动详情
      {
        path: '/marketingCenter/merchant/details',
        name: 'merchantCouponActivityDetail',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/marketingActivity/merchantCouponActivity/Detail'
          ),
        meta: {
          pageTitle: '商户卡券活动详情',
          auth: 'marketing:mcampaign:coupon:detail',
        },
      },
      // 营销管理 商户营销活动 商户卡券活动-领取记录
      {
        path: '/marketingCenter/merchantMarketingTools/marketingActivity/pickUpRecord',
        name: 'merchantCouponActivityPickUpRecord',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/marketingActivity/merchantCouponActivity/PickUpRecord'
          ),
        meta: {
          pageTitle: '商户卡券领取记录',
          auth: 'marketing:mcampaign:coupon:record',
        },
      },
      // 营销管理 商户卡券管理 抵用卡管理
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard',
        name: 'merchantCreditCardList',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard/List'
          ),
        meta: {
          pageTitle: '抵用卡管理',
          auth: 'marketing:mcard:debit',
        },
      },
      // 营销管理 商户卡券管理 抵用卡管理 抵用卡明细
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard/particulars',
        name: 'merchantCreditCardParticulars',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard/Particulars'
          ),
        meta: {
          pageTitle: '抵用卡明细',
          auth: 'marketing:mcard:debit:data',
        },
      },
      // 营销管理 商户卡券管理 抵用卡管理 抵用卡详情
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard/details',
        name: 'merchantCreditCardDetail',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/creditCard/Detail'
          ),
        meta: {
          pageTitle: '抵用卡详情',
          auth: 'marketing:mcard:debit:detail',
        },
      },
      // 营销管理 商户卡券管理 优惠券管理
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/coupon',
        name: 'merchantCouponList',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/coupon/List'
          ),
        meta: {
          pageTitle: '优惠券管理',
          auth: 'marketing:mcard:coupon',
        },
      },
      // 营销管理 商户卡券管理 优惠券管理 优惠券明细
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/coupon/particulars',
        name: 'merchantCouponParticulars',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/coupon/Particulars'
          ),
        meta: {
          pageTitle: '优惠券明细',
          auth: 'marketing:mcard:coupon:data',
        },
      },
      // 营销管理 商户卡券管理 优惠券管理 优惠券详情
      {
        path: '/marketingCenter/merchantMarketingTools/merchantCoupon/coupon/details',
        name: 'merchantCouponDetail',
        component: () =>
          import(
            /* webpackChunkName: 'merchantMarketingTools' */ '../views/marketingCenter/merchantMarketingTools/merchantCoupon/coupon/Detail'
          ),
        meta: {
          pageTitle: '优惠券详情',
          auth: 'marketing:mcard:coupon:detail',
        },
      },
      //  营销管理 广告管理 用户端广告-列表
      {
        path: '/marketingCenter/clientAds/List',
        name: 'clientAdsList',
        component: () => import('../views/marketingCenter/clientAds/List.vue'),
        meta: {
          pageTitle: '用户端广告列表',
          auth: 'marketing:advertise:user',
        },
      },
      //  营销管理 广告管理 用户端广告-详情
      {
        path: '/marketingCenter/clientAds/Detail',
        name: 'clientAdsDetail',
        component: () => import('../views/marketingCenter/clientAds/Detail.vue'),
        meta: {
          pageTitle: '用户端广告详情',
          auth: 'ads:detail',
        },
      },
      // 营销管理 标签分组 用户分组 列表
      {
        path: '/marketingCenter/labelUsers/List',
        name: 'labelUsersList',
        component: () => import('../views/marketingCenter/labelUsers/List.vue'),
        meta: {
          pageTitle: '用户分组列表',
          auth: 'marketing:label:user',
        },
      },
      //  运营管理 标签分组 用户分组 详情
      {
        path: '/marketingCenter/labelUsers/Detail',
        name: 'labelUsersDetail',
        component: () => import('../views/marketingCenter/labelUsers/Detail.vue'),
        meta: {
          pageTitle: '用户分组详情',
          auth: 'group:user:detail',
        },
      },
      // 营销管理 标签分组 电站分组 列表
      {
        path: '/marketingCenter/labelStations/List',
        name: 'labelStationsList',
        component: () => import('../views/marketingCenter/labelStations/List.vue'),
        meta: {
          pageTitle: '电站分组列表',
          auth: 'marketing:label:station',
        },
      },
      //  运营管理 标签分组 电站分组 详情
      {
        path: '/marketingCenter/labelStations/Detail',
        name: 'labelStationsDetail',
        component: () => import('../views/marketingCenter/labelStations/Detail.vue'),
        meta: {
          pageTitle: '电站分组详情',
          auth: 'group:station:detail',
        },
      },
      // 营销管理 普通会员管理 列表
      {
        path: '/marketingCenter/financialMember/vipManage',
        name: 'ordinaryVipList',
        component: () => import('../views/marketingCenter/ordinaryVipManage/vipManage/List.vue'),
        meta: {
          pageTitle: '普通会员',
          auth: 'marketing:financialmember:list',
        },
      },
      // 营销管理 普通会员管理 详情
      {
        path: '/marketingCenter/financialMember/vipManage/details',
        name: 'ordinaryVipDetail',
        component: () => import('../views/marketingCenter/ordinaryVipManage/vipManage/Detail.vue'),
        meta: {
          pageTitle: '普通会员-详情',
          auth: 'marketing:financialmember:list:detail',
        },
      },
      // 营销管理 普通会员管理 详情-积分流水
      {
        path: '/marketingCenter/financialMember/vipManage/integralFlow',
        name: 'ordinaryIntegralFlow',
        component: () =>
          import('../views/marketingCenter/ordinaryVipManage/vipManage/IntegralFlow.vue'),
        meta: {
          pageTitle: '普通会员-积分流水',
          auth: 'marketing:financialmember:list:detail:integralDetail',
        },
      },
      // 营销管理 普通会员管理 详情-成长值流水
      {
        path: '/marketingCenter/financialMember/vipManage/growthValueFlow',
        name: 'ordinaryGrowthValueFlow',
        component: () =>
          import('../views/marketingCenter/ordinaryVipManage/vipManage/GrowthValueFlow.vue'),
        meta: {
          pageTitle: '普通会员-成长值流水',
          auth: 'marketing:financialmember:list:detail:growthDetail',
        },
      },
      // 营销管理 普通会员管理 会员等级配置-列表
      {
        path: '/marketingCenter/financialMember/vipLevel',
        name: 'ordinaryVipLevelList',
        component: () => import('../views/marketingCenter/ordinaryVipManage/vipLevel/List.vue'),
        meta: {
          pageTitle: '普通会员等级配置',
          auth: 'marketing:financialmember:grade',
        },
      },
      // 营销管理 付费会员管理 列表
      {
        path: '/marketingCenter/payMember/vipManage',
        name: 'payVipList',
        component: () => import('../views/marketingCenter/payVipManage/vipManage/List.vue'),
        meta: {
          pageTitle: '付费会员',
          auth: 'marketing:paymember:list',
        },
      },
      // 营销管理 付费会员管理 详情
      {
        path: '/marketingCenter/payMember/vipManage/details',
        name: 'payVipDetail',
        component: () => import('../views/marketingCenter/payVipManage/vipManage/Detail.vue'),
        meta: {
          pageTitle: '付费会员-详情',
          auth: 'marketing:paymember:list:detail',
        },
      },
      // 营销管理 付费会员管理 详情-开通记录
      {
        path: '/marketingCenter/payMember/vipManage/records',
        name: 'payVipRecordFlow',
        component: () => import('../views/marketingCenter/payVipManage/vipManage/RecordFlow.vue'),
        meta: {
          pageTitle: '付费会员-开通记录',
          auth: 'marketing:paymember:list:record',
        },
      },
      // 营销管理 付费会员管理 详情-积分流水
      {
        path: '/marketingCenter/payMember/vipManage/integralFlow',
        name: 'payIntegralFlow',
        component: () => import('../views/marketingCenter/payVipManage/vipManage/IntegralFlow.vue'),
        meta: {
          pageTitle: '付费会员-积分流水',
          auth: 'marketing:paymember:list:detail:integralDetail',
        },
      },
      // 营销管理 付费会员管理 详情-成长值流水
      {
        path: '/marketingCenter/payMember/vipManage/growthValueFlow',
        name: 'PayGrowthValueFlow',
        component: () =>
          import('../views/marketingCenter/payVipManage/vipManage/GrowthValueFlow.vue'),
        meta: {
          pageTitle: '付费会员-成长值流水',
          auth: 'marketing:paymember:list:detail:growthDetail',
        },
      },
      // 付费会员-配置-列表
      {
        path: '/marketingCenter/payMember/payVipConfig',
        name: 'payVipConfigList',
        component: () => import('../views/marketingCenter/payVipManage/payVipConfig/List.vue'),
        meta: {
          pageTitle: '付费会员配置',
          auth: 'marketing:paymember:grade',
        },
      },
      // 营销管理-付费会员-购买策略配置
      {
        path: '/marketingCenter/payMember/purchaseConfig',
        name: 'purchaseConfigList',
        component: () => import('../views/marketingCenter/payVipManage/purchaseConfig/List.vue'),
        meta: {
          pageTitle: '付费会员-购买策略配置',
          auth: 'marketing:paymember:purchase',
        },
      },
      // 营销管理-付费会员-购买策略详情
      {
        path: '/marketingCenter/payMember/purchaseConfig/detail',
        name: 'purchaseConfigDetail',
        component: () => import('../views/marketingCenter/payVipManage/purchaseConfig/Detail.vue'),
        meta: {
          pageTitle: '付费会员-购买策略配置详情',
          auth: 'marketing:paymember:purchaseConfig:detail',
        },
      },
      /** ***************************************商户管理****************************************** */
      //  商户管理 平台商户 商户列表
      {
        path: '/merchantCenter/merchantPlatform/List',
        name: 'platformMerchantList',
        component: () => import('../views/merchantCenter/merchantPlatform/List.vue'),
        meta: {
          pageTitle: '平台商户管理',
          auth: 'merchant:platform:list',
        },
      },
      //  商户管理 平台商户 商户详情
      {
        path: '/merchantCenter/merchantPlatform/Detail',
        name: 'platformMerchantDetail',
        component: () => import('../views/merchantCenter/merchantPlatform/Detail.vue'),
        meta: {
          pageTitle: '商户详情',
          auth: 'merchant:platform:detail',
        },
      },
      //  商户管理 互联商户 商户列表
      // {
      //   path: '/merchantCenter/merchantUnion/List',
      //   name: 'merchantUnionList',
      //   component: () => import('../views/merchantCenter/merchantUnion/List.vue'),
      //   meta: {
      //     pageTitle: '互联商户管理',
      //     auth: 'merchant:connect:list',
      //   },
      // },
      /** ***************************************客户管理****************************************** */
      //  客户管理 充电客户 客户机构列表
      {
        path: '/customerCenter/customerCharge/organization/organizationList',
        name: 'customerChargeList',
        component: () => import('../views/customerCenter/customerCharge/organization/List.vue'),
        meta: {
          pageTitle: '客户机构列表',
          auth: 'driver:charge:org',
        },
      },
      //  客户管理 充电客户 客户机构详情
      {
        path: '/customerCenter/customerCharge/organization/Detail',
        name: 'customerChargeDetail',
        component: () => import('../views/customerCenter/customerCharge/organization/Detail.vue'),
        meta: {
          pageTitle: '客户机构详情',
          auth: 'driver:charge:org',
        },
      },
      //  客户管理 充电客户 客户司机列表
      {
        path: '/customerCenter/customerCharge/customerDriver/customerDriverList',
        name: 'customerDriverList',
        component: () => import('../views/customerCenter/customerCharge/customerDriver/List.vue'),
        meta: {
          pageTitle: '客户司机列表',
          auth: 'driver:consumer:driver',
        },
      },
      //  客户管理 充电客户 客户司机详情
      {
        path: '/customerCenter/customerCharge/customerDriver/customerDriverDetail',
        name: 'customerDriverDetail',
        component: () => import('../views/customerCenter/customerCharge/customerDriver/Detail.vue'),
        meta: {
          pageTitle: '司机详情',
          auth: 'customer:customer:detail',
        },
      },
      // 客户管理 充电客户 客户司机详情 信用付记录
      {
        path: '/customerCenter/customerCharge/customerDriver/customerDriverDetail/creditPayRecord',
        name: 'creditPayRecord',
        component: () =>
          import('../views/customerCenter/customerCharge/customerDriver/CreditPayRecord.vue'),
        meta: {
          pageTitle: '信用付记录',
          auth: 'customer:customer:detail',
        },
      },
      // 客户管理 充电客户 客户司机详情 车辆绑定记录
      {
        path: '/customerCenter/customerCharge/customerDriver/customerDriverDetail/bindRecord',
        name: 'bindRecord',
        component: () =>
          import('../views/customerCenter/customerCharge/customerDriver/BindRecord.vue'),
        meta: {
          pageTitle: '车辆绑定记录',
          auth: 'customer:customer:detail',
        },
      },
      //  客户管理 充电客户 客户车辆列表
      {
        path: '/customerCenter/customerCharge/customerVehicle/customerVehicleList',
        name: 'customerVehicleList',
        component: () => import('../views/customerCenter/customerCharge/customerVehicle/List.vue'),
        meta: {
          pageTitle: '客户车辆列表',
          auth: 'driver:charge:car',
        },
      },
      //  客户管理 充电客户 客户车辆详情
      {
        path: '/customerCenter/customerCharge/customerVehicle/customerVehicleDetail',
        name: 'customerVehicleDetail',
        component: () =>
          import('../views/customerCenter/customerCharge/customerVehicle/Detail.vue'),
        meta: {
          pageTitle: '客户车辆详情',
          auth: 'driver:charge:car',
        },
      },
      //  客户管理 充电客户 充电司机
      {
        path: '/customerCenter/customerCustomer/customerCustomerList',
        name: 'customerCustomerList',
        component: () => import('../views/customerCenter/customerCustomer/List.vue'),
        meta: {
          pageTitle: '充电司机',
          auth: 'driver:consumer:driver',
        },
      },
      //  客户管理 内部司机 机构车辆列表
      {
        path: '/customerCenter/internalDriver/subsidiaryVehicle/subsidiaryVehicleList',
        name: 'subsidiaryVehicleList',
        component: () =>
          import('../views/customerCenter/internalDriver/subsidiaryVehicle/List.vue'),
        meta: {
          pageTitle: '机构车辆列表',
          auth: 'customer:customer:detail',
        },
      },
      /** ***************************************互联互通管理START****************************************** */
      // 互联互通管理 互联客户管理 列表
      {
        path: '/connectManagement/customerUnion/customerUnionList',
        name: 'customerUnionList',
        component: () => import('../views/connectManagement/customerUnion/List.vue'),
        meta: {
          pageTitle: '互联互通客户',
          auth: 'connect:client',
        },
      },
      // 互联互通管理 互联客户管理 详情
      {
        path: '/connectManagement/customerUnion/customerUnionDetail',
        name: 'customerUnionDetail',
        component: () => import('../views/connectManagement/customerUnion/Detail.vue'),
        meta: {
          pageTitle: '互联互通客户详情',
          auth: 'connect:client:detail',
        },
      },
      // 互联互通管理 互联推送管理 列表
      {
        path: '/connectManagement/cipherUnion/cipherUnionList',
        name: 'cipherUnionList',
        component: () => import('../views/connectManagement/cipherUnion/List.vue'),
        meta: {
          pageTitle: '互联推送管理',
          auth: 'connect:push',
        },
      },
      // 互联互通管理 互联推送管理 详情
      {
        path: '/connectManagement/cipherUnion/cipherUnionDetail',
        name: 'cipherUnionDetail',
        component: () => import('../views/connectManagement/cipherUnion/Detail.vue'),
        meta: {
          pageTitle: '互联推送详情',
          auth: 'connect:push:detail',
        },
      },
      /** ***************************************互联互通管理END****************************************** */
      /** ***************************************运维管理****************************************** */
      // 运维管理 告警中心 告警设置
      {
        path: '/operationManagement/alarmInfo/alarmSettingList',
        name: 'alarmInfoSettingList',
        component: () => import('../views/operationManagement/alarmInfo/alarmSetting/List.vue'),
        meta: {
          pageTitle: '告警设置',
          auth: 'maintain:alarm:setting',
        },
      },
      //  运维管理 告警中心 告警信息
      {
        path: '/operationManagement/alarmInfo/omAlarmsInfoList',
        name: 'omAlarmsInfoList',
        component: () => import('../views/operationManagement/alarmInfo/OMAlarmsInfoList.vue'),
        meta: {
          pageTitle: '告警信息',
          auth: 'maintain:alarm:list',
        },
      },
      //  运维管理 告警中心 告警统计
      {
        path: '/operationManagement/alarmInfo/alarmStatistics',
        name: 'alarmStatistics',
        component: () => import('../views/operationManagement/alarmInfo/alarmStatistics.vue'),
        meta: {
          pageTitle: '告警统计',
          auth: 'maintain:alarm:statistics',
        },
      },
      //  运维管理 设备运维 设备报文
      {
        path: '/operationManagement/deviceOM/deviceMessageList',
        name: 'deviceMessageList',
        component: () => import('../views/operationManagement/deviceOM/DeviceMessageList.vue'),
        meta: {
          pageTitle: '设备报文',
          auth: 'maintain:alarm:msg',
        },
      },
      //  运维管理 设备运维 远程升级
      {
        path: '/operationManagement/deviceOM/remoteUpgradeList',
        name: 'remoteUpgradeList',
        component: () => import('../views/operationManagement/deviceOM/RemoteUpgradeList.vue'),
        meta: {
          pageTitle: '远程升级',
          auth: 'maintain:alarm:remoteupgrade',
        },
      },
      //  系统设置 用户配置 用户反馈
      {
        path: '/systemSettings/feedbackList',
        name: 'feedbackList',
        component: () => import('../views/operationManagement/feedback/List.vue'),
        meta: {
          pageTitle: '反馈信息',
          auth: 'sys:userconfig:reback',
        },
      },

      {
        path: '/operationManagement/feedback/Detail',
        name: 'feedbackDetail',
        component: () => import('../views/operationManagement/feedback/Detail.vue'),
        meta: {
          pageTitle: '反馈信息详情',
          // auth: 'maintain:user:feedback:detail',
          auth: 'sys:log:list',
        },
      },
      // 运维巡检-运维工单-列表
      {
        path: '/operationManagement/polling/workOrderList',
        name: 'workOrderList',
        component: () => import('../views/operationManagement/polling/workOrderList.vue'),
        meta: {
          pageTitle: '运维工单',
          auth: 'maintain:workorder:list',
        },
      },
      // 运维巡检-运维工单-详情
      {
        path: '/operationManagement/polling/workOrderDetail',
        name: 'workOrderDetail',
        component: () => import('../views/operationManagement/polling/workOrderDetail.vue'),
        meta: {
          pageTitle: '运维工单详情',
          auth: 'maintain:workorder:list:detail',
        },
      },
      // 运维巡检-巡检任务-列表
      {
        path: '/operationManagement/polling/inspectionList',
        name: 'inspectionList',
        component: () => import('../views/operationManagement/polling/inspectionList.vue'),
        meta: {
          pageTitle: '巡检任务',
          auth: 'inspection:task:list',
        },
      },
      // 运维巡检-巡检任务-详情
      {
        path: '/operationManagement/polling/inspectionDetail',
        name: 'inspectionDetail',
        component: () => import('../views/operationManagement/polling/inspectionDetail.vue'),
        meta: {
          pageTitle: '巡检任务详情',
          auth: 'inspection:task:list:detail',
        },
      },
      // 元数据管理-场站管理-列表
      {
        path: '/operationManagement/metadata/stationList',
        name: 'stationList',
        component: () => import('../views/operationManagement/metadata/stationList.vue'),
        meta: {
          pageTitle: '场站管理',
          auth: 'metadata:management:station',
        },
      },
      // 元数据管理-巡检项管理-列表
      {
        path: '/operationManagement/metadata/serviceAvailableList',
        name: 'serviceAvailableList',
        component: () => import('../views/operationManagement/metadata/serviceAvailableList.vue'),
        meta: {
          pageTitle: '巡检项管理',
          auth: 'metadata:management:service',
        },
      },
      // 运维管理-工单统计-工单服务统计列表
      {
        path: '/operationManagement/workstatistics/workServerList',
        name: 'workServerList',
        component: () => import('../views/operationManagement/workstatistics/workServerList.vue'),
        meta: {
          pageTitle: '工单服务统计',
          auth: 'workorder:statistics:servestat',
        },
      },
      // 运维管理-工单统计-考核统计列表
      {
        path: '/operationManagement/workstatistics/assessList',
        name: 'assessList',
        component: () => import('../views/operationManagement/workstatistics/assessList.vue'),
        meta: {
          pageTitle: '考核统计',
          auth: 'workorder:statistics:assess',
        },
      },
      // 菜单管理 前端自用
      {
        path: '/menuSetting',
        name: 'menuSetting',
        component: () => import('../views/systemSettings/menuSetting/index.vue'),
        meta: {
          pageTitle: '菜单管理',
          auth: 'ADMIN',
        },
      },
      /** ***************************************系统设置****************************************** */
      //  系统设置 系统操作日志 操作日志
      {
        path: 'systemSettings/operationLog/operationLog',
        name: 'operationLog',
        component: () =>
          import(
            /* webpackChunkName: 'operationLog' */ '../views/systemSettings/operationLog/List.vue'
          ),
        meta: {
          pageTitle: '操作日志',
          auth: 'sys:log:list',
        },
      },
      //  系统设置 权限管理 账号管理
      {
        path: 'systemSettings/powerManage/accountManage',
        name: 'accountManage',
        component: () =>
          import(
            /* webpackChunkName: 'accountManage' */ '../views/systemSettings/powerManage/accountManage/List.vue'
          ),
        meta: {
          pageTitle: '账号管理',
          auth: 'sys:account',
        },
      },
      //  系统设置 权限管理 账号管理 账号详情
      {
        path: 'systemSettings/powerManage/accountManage/details',
        name: 'accountManageDetail',
        component: () =>
          import(
            /* webpackChunkName: 'accountManage' */ '../views/systemSettings/powerManage/accountManage/Detail.vue'
          ),
        meta: {
          pageTitle: '账号详情',
          auth: 'sys:account:detail',
        },
      },
      //  系统设置 权限管理 角色管理
      {
        path: 'systemSettings/powerManage/roleManage',
        name: 'roleManage',
        component: () =>
          import(
            /* webpackChunkName: 'roleManage' */ '../views/systemSettings/powerManage/roleManage/List.vue'
          ),
        meta: {
          pageTitle: '角色管理',
          auth: 'sys:role',
        },
      },
      //  系统设置 权限管理 角色管理 角色详情
      {
        path: 'systemSettings/powerManage/roleManage/details',
        name: 'roleManageDetail',
        component: () =>
          import(
            /* webpackChunkName: 'roleManage' */ '../views/systemSettings/powerManage/roleManage/Detail.vue'
          ),
        meta: {
          pageTitle: '角色详情',
          auth: 'sys:role:detail',
        },
      },
      //  系统设置 系统配置 系统配置
      {
        path: 'systemSettings/systemConfig/systemConfig',
        name: 'systemConfigList',
        component: () =>
          import(
            /* webpackChunkName: 'roleManage' */ '../views/systemSettings/systemConfig/systemConfig/List.vue'
          ),
        meta: {
          pageTitle: '系统配置',
          auth: 'sys:config:list',
        },
      },
      //  系统设置 系统消息 系统通知
      {
        path: 'systemSettings/systemNotice/noticeManage',
        name: 'noticeManageList',
        component: () =>
          import(
            /* webpackChunkName: 'noticeManage' */ '../views/systemSettings/systemNotice/noticeManage/List.vue'
          ),
        meta: {
          pageTitle: '系统通知',
          auth: 'sys:noticelsit',
        },
      },
      //  系统设置 系统消息 系统通知 详情
      {
        path: 'systemSettings/systemNotice/noticeManage/Detail',
        name: 'noticeManageDetail',
        component: () =>
          import(
            /* webpackChunkName: 'noticeManageDetail' */ '../views/systemSettings/systemNotice/noticeManage/Detail.vue'
          ),
        meta: {
          pageTitle: '系统通知详情',
          // auth: 'sys:noticelsit:detail',
          auth: 'sys:noticelsit',
        },
      },
      //  系统设置 下载中心 下载列表
      {
        path: 'systemSettings/downloadCenter',
        name: 'downloadCenterList',
        component: () =>
          import(
            /* webpackChunkName: 'noticeManage' */ '../views/systemSettings/downloadCenter/List.vue'
          ),
        meta: {
          pageTitle: '下载中心',
          auth: 'sys:downloadlist',
        },
      },
      //  系统设置 协议管理 协议列表
      {
        path: 'systemSettings/consultativeManage/consultativeList',
        name: 'consultativeList',
        component: () =>
          import(
            /* webpackChunkName: 'consultativeList' */ '../views/systemSettings/consultativeManage/List.vue'
          ),
        meta: {
          pageTitle: '协议管理',
          auth: 'sys:consultative:manage',
        },
      },
      //  系统设置 常见问题 常见问题列表
      {
        path: 'systemSettings/commonissue/commonissueList',
        name: 'commonProblem',
        component: () =>
          import(
            /* webpackChunkName: 'commonProblem' */ '../views/systemSettings/commonissue/List.vue'
          ),
        meta: {
          pageTitle: '常见问题',
          auth: 'sys:commonissue:list',
        },
      },
      //  系统设置 版本更新
      {
        path: 'systemSettings/upgradeManage',
        name: 'upgradeManage',
        component: () =>
          import(
            /* webpackChunkName: 'upgradeManage' */ '../views/systemSettings/upgradeManage/List.vue'
          ),
        meta: {
          pageTitle: '版本更新',
          auth: 'sys:upgradelist',
        },
      },
    ],
  },

  // 大屏
  {
    path: '/',
    component: EmptyLayout,
    children: [
      // #region 大屏
      // {
      //   path: 'overview/operation',
      //   name: 'OverviewOperation',
      //   component: () =>
      //     import(/* webpackChunkName: 'OverviewOperation' */ '@/views/overview/operation/Main.vue'),
      //   meta: {
      //     pageTitle: '运营大屏',
      //     auth: 'dashboard',
      //   },
      // },
      // #endregion
    ],
  },
];

export default [
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'Login' */ '../views/Login.vue'),
  },
  {
    path: '/NotFound',
    meta: {},
    component: () => import(/* webpackChunkName: 'NotFound' */ '../views/NotFound.vue'),
  },
  {
    path: '*',
    redirect: '/NotFound',
    // component: () => import(/* webpackChunkName: 'NotFound' */ '../views/NotFound.vue'),
  },
];
